const STORAGE_KEY = "dropchances";

function normalizeItem(raw) {
  if (!raw || typeof raw !== "object") {
    return { title: "", dropchance: 1, runs: 0 };
  }

  const title =
    typeof raw.title === "string" ? raw.title : String(raw.title ?? "");

  let dropchance = parseFloat(raw.dropchance);
  if (!Number.isFinite(dropchance)) {
    dropchance = 1;
  }
  dropchance = Math.max(0, Math.min(100, dropchance));

  const runsParsed = parseInt(raw.runs, 10);
  const runs =
    raw.runs === "" || raw.runs === null || raw.runs === undefined
      ? 0
      : Number.isFinite(runsParsed) && runsParsed >= 0
        ? runsParsed
        : 0;

  const item = { title, dropchance, runs };
  if (raw.found) {
    item.found = true;
  }
  return item;
}

// Load saved items; returns [] on missing, corrupt, or invalid data.
export function loadDropchances() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [];
    }

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed.map(normalizeItem);
  } catch {
    return [];
  }
}

// Persist items; returns false if storage is unavailable or full.
export function saveDropchances(dropchances) {
  if (!Array.isArray(dropchances)) {
    return false;
  }

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(dropchances));
    return true;
  } catch {
    return false;
  }
}
